import { APIcallerv2 } from './APIcaller';

const isStefIntegrationEnabled = async () =>
  APIcallerv2.apiGet('/partnerships/stef-order-availability/is-activated');

const getStefOrderAvailabilityConfig = async () =>
  APIcallerv2.apiGet('/partnerships/stef-order-availability/credentials');

const updateStefOrderAvailabilityConfig = async (credentials) =>
  APIcallerv2.apiPost('/partnerships/stef-order-availability/credentials', { credentials });

export default {
  isStefIntegrationEnabled,
  getStefOrderAvailabilityConfig,
  updateStefOrderAvailabilityConfig,
};
